import { post, get } from './fetchUtil';

//get方式

//connection连接websocket
export async function connectionSocket() {
  return get(`/connection`);
}

/**
 * 获取房间成员列表
 * @param roomId 房间号
 */
export async function queryUserList(params) {
  return post('/queryUserList', params);
}
/**
 * 离开会议房间
 * @param roomId 房间号
 * @param idNumber 工号
 */
export async function leaveRoom(params) {
  return post('/leaveRoom', params);
}

/**
 * 离开会议房间
 * @param roomId 房间号
 * @param idNumber 工号
 */
export async function translate(params) {
  return post('/translate', params);
}

/**
 * 切换语言
 * @param clientID 房间号
 * @param roomID 工号
 * @param language 语言
 */
export async function switchLanguage(params) {
  return post('/switchLanguage', params);
}
/*
 * 使用 POST 方法查询语言
 */
export async function queryLanguage() {
  return post('/queryLanguage', {});
}
export async function getRoomLanguageList(params) {
  return post('/getRoomLanguageList', params);
}
/*
 * 使用 POST 方法加入房间
 */
export async function JoinRoom(params) {
  return await post('/joinRoom', params);
}

/*
 * 使用 POST 创建会议并加入房间
 */
export async function createRoom(params) {
  return post('/createRoom', params);
}

// 当前使用麦克风的用户
export async function setMicphoneStatus(params) {
  return post('/setMicphoneStatus', params);
}
// 当前使用麦克风的用户
export async function queryRoomLanguage(params) {
  return post('/queryRoomLanguage', params);
}
//查询user列表
export async function queryUserInfo(params) {
  if (params) {
    return post('/queryUserInfo', params);
  } else {
    return post('/queryUserInfo');
  }

}
//新增/修改user信息
export async function addAndEditUserInfo(params, type) {
  if (type === 'add') {
    return post('/addUserInfo', params);
  } else {
    return post('/updateUserInfo', params);
  }
}
//删除user信息
export async function deleteUserInfo(params) {
  return post('/deleteUserInfo', params);
}

// 获取加密信息
// export function getScription(params) {
//   return post('/subScription', params);
// }
//发送翻译消息到后台
export async function sendMessage(params) {
  return post('/output/start', params);
}
//登录
export async function login(params) {
  return post('/login', params);
}
//登录
export async function logout() {
  return post('/logout', {});
}
//发送聊天信息
export async function sendChatMsg(params) {
  return post('/sendChat', params);
}

// 专有名词导入
export async function importSpecialWords() {
  return post('/queryPhraselist', {phrase:"all"});
}

// setting cost数据
export async function queryCostLog(params) {
  return post('/queryCostLog', params);
}

//聊天记录
export async function queryChatLog(params) {
  return post('/queryChatLog', params);
}

//历史翻译记录
export async function queryChatHistory(params) {
  return post('/queryChatHistory', params);
}

//权限申请
export async function addAccessRequest(params) {
  return post('/addAccessRequest', params);
}

//获取申请的列表
export async function queryAccessRequests(params) {
  return post('/queryAccessRequests', params);
}

//同意申请
export async function approveAccessRequests(params) {
  return post('/approveAccessRequests', params);
}

//拒绝申请
export async function rejectAccessRequests(params) {
  return post('/rejectAccessRequests', params);
}

//设置房间语言
export async function putRoomLanguageList(params) {
  return post('/putRoomLanguageList', params);
}

//设置房间语言
export async function getSpeechToken() {
  return post('/getSpeechToken', {});
}

// 通过语言  工号  获取对应的词条列表
export async function queryPhraselist(params) {
return post('/queryPhraselist', params);
}

// 通过语言  工号  获取对应的词条列表
export async function queryPhraseListByTitle(params) {
  return post('/queryPhraselistByTitle', params);
}

// 通过语言  工号  获取对应的词条列表
export async function deletePhraseList(params) {
  return post('/deletePhrase', params);
}

// 通过 id 修改相应的词条
export async function updatePhraseList(params) {
  return post('/updatePhrase', params);
}

// 新增相应的词条
export async function addPhraseList(params) {
  return post('/addPhrase', params);
}

// 获取语速列表
export async function getSpeechRateList() {
  return post('/getSpeechRateList', {});
}

// 获取语速
export async function getSpeechRate(params) {
  return post('/getSetting', params);
}

// 设置语速
export async function setSpeechRate(params) { 
  return post('/setSetting', params);
} 

// 设置windows guide
export async function setWindowsGuide(params) {
  return post('/setSetting', params);
}

export async function getWindowsGuide(params) {
    return post('/getSetting', params);
}

export async function getContactUsData() {
  return post('/contactUs');
}

// 获取当前版本信息
export async function getWindowsVersion() {
  return post('/getWindowsVersion');
}